import { render } from "./BuildingItem.vue?vue&type=template&id=4a5b1dd0"
import script from "./BuildingItem.vue?vue&type=script&lang=js"
export * from "./BuildingItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__